import { render, staticRenderFns } from "./Visas.vue?vue&type=template&id=41b55e4f&scoped=true&"
import script from "./Visas.vue?vue&type=script&lang=js&"
export * from "./Visas.vue?vue&type=script&lang=js&"
import style0 from "./Visas.vue?vue&type=style&index=0&id=41b55e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b55e4f",
  null
  
)

export default component.exports